import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getEquipmentTypeAvailableColumns } from './api';

export const path = '/ppr/equipment-type/list';

const PageEquipmentTypes: React.FC = (props) => {
  const EquipmentTypes = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getEquipmentTypeAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <EquipmentTypes {...props} />;
};

export default PageEquipmentTypes;
